import type {
  DiscoverClientSource,
  DiscoverEvidenceBlock,
  DiscoverNoteSource,
} from "../shared/source-contract";
import { GenericEvidenceCard } from "./generic-evidence-card";
import { RssNoteSourceCard } from "./rss-note-source-card";

/** RSS-family evidence: blog feeds and Exa gap-sweep pages. */
export const rssClientSource = {
  id: "rss",
  matches({
    sourceType,
  }: {
    sourceType: string;
    sourceId: string;
    metadata: Record<string, unknown>;
  }) {
    return sourceType.toUpperCase() === "RSS";
  },
  renderEvidence({
    block,
    key,
  }: {
    block: DiscoverEvidenceBlock;
    key: string;
  }) {
    return <GenericEvidenceCard block={block} key={key} />;
  },
  renderNoteSource({
    note,
  }: {
    exploreBase: string;
    note: DiscoverNoteSource;
    onOpenChange: (open: boolean) => void;
  }) {
    return <RssNoteSourceCard note={note} />;
  },
} satisfies DiscoverClientSource;
